import { cloneDeep, find, isEqual, unset, values } from 'lodash'

import GenericStoreCoordinatorInstance from 'Services/genericStoreCoordinator/Instance'
import { v4 as uuid } from 'uuid'

class GenericStoreCoordinatorService {
  instances = []

  create (storeType, instanceOpts, referenceName) {
    return new GenericStoreCoordinatorInstance(uuid(), storeType, instanceOpts, referenceName)
  }

  getById (uuid, storeType = null) {
    if (this.instances[uuid]) {
      return this.instances[uuid]
    } else if (storeType) {
      return this.create(storeType)
    } else {
      console.error(
        'Argument Missing: Must provide `storeType` to create a new GenericStoreCoordinatorInstance.'
      )
      return null
    }
  }

  get (storeType, instanceOpts, referenceName = undefined) {
    if (referenceName) {
      const ref = this.getByReferenceName(referenceName)
      return ref || this.create(storeType, instanceOpts, referenceName)
    } else {
      return this.getByType(storeType, instanceOpts, referenceName)
    }
  }

  getByType (storeType, instanceOpts) {
    // We need to try to find a store that has the same type and instanceOpts.
    // Equality checks will fail on functions, though, so we are going to
    // blacklist the paths to the two transform functions and remove them from
    // the two comparison objects before performing the comparison.
    const blacklist = [
      'slaveTo.masterFilterTransform',
      'slaveTo.slaveFilterTransform',
      'slaveTo.slaveMergeFieldsTransform',
      'slaveTo.masterMergeFieldsTransform',
    ]
    const clonedInstanceOpts = cloneDeep(instanceOpts)
    // Remove blacklisted keys
    blacklist.forEach(path => {
      unset(clonedInstanceOpts, path)
    })

    const res = values(this.instances).find(inst => {
      const clonedIteratorOpts = cloneDeep(inst._instanceOpts)
      // Remove blacklisted keys
      blacklist.forEach(path => {
        unset(clonedIteratorOpts, path)
      })
      // Compare
      return inst.type === storeType && isEqual(clonedInstanceOpts, clonedIteratorOpts)
    })

    if (res) {
      res.reloadDataStore()
    }

    // If we don't find a service that matches, make a new one.
    return res || this.create(storeType, instanceOpts)
  }

  getByReferenceName (referenceName) {
    const found = find(values(this.instances), { referenceName })
    if (!found) {
      // console.warn('-- Unable to find GenericStoreCoordinator for referenceName:', referenceName)
    } else {
      found.reloadDataStore()
    }
    return found
  }

  _registerChildInstance (instance) {
    this.instances[instance.uuid] = instance
  }
}

const _genericStoreCoordinatorService = new GenericStoreCoordinatorService()
export default _genericStoreCoordinatorService
